// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"74":"4138d388","78":"83c89230","261":"a6ba66ec","338":"e210564a","541":"e55c4bee","544":"07dcb03d","576":"8812d508","605":"486178f5","753":"a36a59eb","775":"2c68da4b","980":"d479e852"}[chunkId] + ".js";
};